module.exports = __webpack_public_path__ + "img/icon-mover-cover.d5f5625a.png";